import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { TeamLeadPermissionRole } from '@scale/shared/types/expertManagement';
import queryString from 'query-string';
import { AdminPage } from 'react-scale/components/ExpertManagement/AdminPage/AdminPage';
import { CommunityManagementPage } from 'react-scale/components/ExpertManagement/CommunityManagement/CommunityManagementPage';
import { SpeedAuditModal } from 'react-scale/components/ExpertManagement/ExpertManagementPage/SpeedAuditModal';
import { TeamLeadOverview } from 'react-scale/components/ExpertManagement/ExpertManagementPage/TeamLeadOverview/TeamLeadOverview';
import { WebinarSessionsPage } from 'react-scale/components/ExpertManagement/WebinarSessionsPage/WebinarSessionsPage';
import UserPage from 'react-scale/components/ExpertManagement/ExpertManagementPage/UserPage';
import { NotAuthorized } from 'react-scale/components/ExpertManagement/NotAuthorized';
import { PrivateRoute } from 'react-scale/components/ExpertManagement/PrivateRoute';
import { Routes } from 'react-scale/components/ExpertManagement/urls';
import GlobalPage from './ExpertManagementPage/GlobalPage';
import { Flex, Callout, Icon } from '@scale/scaleui-radix';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';

export const ExpertManagementContent: React.FC = () => {
  const location = useLocation();
  const { user, podType } = queryString.parse(location.search);
  const isAuthorized = useUnleashFeatureFlag('show-team-lead-dashboard', {}, false);

  if (!isAuthorized) {
    return <NotAuthorized />;
  }

  return (
    <div className="w-full">
      <DeprecationBanner />
      <Switch>
        <Route exact path={Routes.ExpertManagement}>
          {!!user && <UserPage userId={user as string} />}
          {!user && !!podType && <GlobalPage />}
          {!user && !podType && <TeamLeadOverview />}
          <SpeedAuditModal />
        </Route>
        <PrivateRoute
          path={Routes.Admin}
          component={AdminPage}
          permissions={[TeamLeadPermissionRole.SuperAdmin]}
        />
        <PrivateRoute
          path={Routes.Community}
          component={CommunityManagementPage}
          permissions={[
            TeamLeadPermissionRole.PodTypeCommunityManager,
            TeamLeadPermissionRole.SuperAdmin,
            TeamLeadPermissionRole.GlobalCommunityManager,
          ]}
        />
        <PrivateRoute
          path={Routes.WebinarSessions}
          component={WebinarSessionsPage}
          permissions={[TeamLeadPermissionRole.SuperAdmin]}
        />
      </Switch>
    </div>
  );
};

const DeprecationBanner = () => {
  return (
    <Flex direction="column" gap="4" p="4">
      <Callout.Root size="2" color="warning">
        <Callout.Icon>
          <Icon icon={faExclamationTriangle} label="info" />
        </Callout.Icon>
        <Callout.Text size="2">
          Team Lead Dashboard is set to be shut down in the coming days. Still need it? Please reach
          out to @chris.butcher on Slack.
        </Callout.Text>
      </Callout.Root>
    </Flex>
  );
};
